import { useEffect, useRef } from "react";

// Components
import Button from "../Button/Button";

// Utils
import { sentenceCaseTyping } from "../../../utils";

// Styles
import { TextFileWithButtonStyles } from "../TextField/textFieldWithButton.styles";

const TextFieldWithButton = ({
  id,
  name,
  autoComplete = "off",
  placeholder = "Create a comment",
  onChange,
  value,
  error,
  touched,
  onBlur,
  onClick,
  disabled,
  maxLength
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  const length = typeof value === "string" ? value.length : 0;
  const isAtLimit = maxLength && length >= maxLength;

  return (
    <TextFileWithButtonStyles $value={value}>
      <div className="inputContainer">
        <textarea
          ref={textareaRef}
          id={id}
          name={name}
          rows={1}
          autoComplete={autoComplete}
          autoCapitalize="sentences"
          className={`input ${touched && error && "error"}`}
          onChange={e => {
            const cased = sentenceCaseTyping(
              value,
              e.target.value,
              e.target.selectionStart
            );
            if (cased === e.target.value) {
              onChange && onChange(e);
              return;
            }
            // Reuse the original synthetic event but with the cased value so
            // formik/controllers see the corrected text.
            e.target.value = cased;
            onChange && onChange(e);
          }}
          value={value}
          onBlur={onBlur}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        <p className="errorMessage">{touched && error && error}</p>
        <Button className="button" onClick={onClick} disabled={disabled}>
          Add
        </Button>
      </div>
      {maxLength && (
        <div className={`charCounter ${isAtLimit ? "atLimit" : ""}`}>
          {length}/{maxLength}
        </div>
      )}
    </TextFileWithButtonStyles>
  );
};

export default TextFieldWithButton;
